import { createI18n } from 'vue-i18n'

import en from './locales/en'

export type AvailableLocales = 'en'

// English only: the portal is operated by Telecel, and a second translation was one more
// file to keep in step with every string added.
const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           'en',
    fallbackLocale:   'en',
    messages:         { en },
    availableLocales: ['en'],
})

export default i18n
